import React, { PropsWithChildren } from "react";
import "./formInputContainer.scss";

export type DKFormInputLabelContainerProps = PropsWithChildren<{
  className?: string;
  size?: "normal" | "compact";
  label: string;
}>;

const DKFormInputLabelContainer = ({
  size = "normal",
  className = "",
  label = "",
  children,
}: DKFormInputLabelContainerProps) => {
  return (
    <div
      className={`form-input-container ${className}`}
      style={size == "compact" ? { marginBottom: 0 } : undefined}
    >
      <div className="label">{label}</div>
      <div>{children}</div>
    </div>
  );
};

export default DKFormInputLabelContainer;
